/*LIBRARY*/
import { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "../Style/muiMapidTheme";

/*COMPONENT*/
import Navigation from "../Components/layout/Navigation";
import MODAL_SHARE_LINK from "../Components/trivial_components/MODAL_SHARE_LINK";
import SNACKBAR_PARENT from "../Components/common_modal/SNACKBAR_PARENT";
import BlogRead from "../Pages/dashboard/BlogRead";
import CreateForm from "../Pages/dashboard/CreateForm";
import PROJECT from "../Pages/dashboard/PROJECT";
import DashboardPublic from "../Pages/dashboard/DashboardPublic";
import EditProfile from "../Pages/user_and_group/EditProfile";
import GROUP_LIST_DASHBOARD from "../Pages/user_and_group/GROUP_LIST_DASHBOARD";
import GROUP_DETAIL from "../Pages/user_and_group/GROUP_DETAIL";
import LandingForgetPassword from "../Pages/auth/LandingForgetPassword";
import LandingLogin from "../Pages/auth/LandingLogin";
import LandingRegister from "../Pages/auth/LandingRegister";
import RoutingAccess from "../Pages/user_and_group/RoutingAccess";
import UserDashboard from "../Pages/user_and_group/UserDashboard";
import { PARENT_MAP_EDITOR, PARENT_MAP_VIEWER } from "../Pages/map/PARENT_MAP";
import PaymentInstruction from "../Pages/dashboard/PaymentInstruction";
import Recovery from "../Pages/dashboard/Recovery";
import BI_PAGE from "../Pages/map/BI_PAGE";
import CollaboratorsMenu from "../Pages/user_and_group/CollaboratorsMenu";
import GROUP_MENU from "../Pages/user_and_group/groupMenu";
import DeleteAccount from "../Pages/user_and_group/DeleteAccount";
import FloodSystemAnalysis from "../Pages/user_and_group/FloodSystemAnalysis";

/*REDUX*/
import {
  setCurrentUser,
  getUserFromToken,
  setPathname,
  setPrevPathname,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
  logoutUser,
  setLanguage,
} from "../App/actions/authActions";
import { getUserPaymentList } from "../App/actions/paymentActions";
import { optimized_get_user_license } from "../App/actions/license_actions";

/*PICTURE*/

/*FUNCTION*/
import { PrivateRoute } from "../App/validation";
import history from "../App/actions/history";
import store from "./store";

/*DATA*/
/*CSS MAIN*/
import "../Style/main/color.css";
import "../Style/main/container.css";
import "../Style/main/main_tag.css";
import "../Style/main/shape.css";
import "../Style/main/variable.css";
import "../Style/main/table.css";

/*CSS TRIVIAL*/
import "../Style/trivial/old.css";
import "../Style/trivial/chat_container.css";
import "../Style/trivial/animation.css";
import "../Style/trivial/Rich.css";
import "../Style/trivial/SingleStyle.css";
import "../Style/trivial/bi.css";
import "../Style/trivial/map_control.css";
import "../Style/trivial/map_control_draw.css";
import "../Style/trivial/map_control_trivial.css";
import "../Style/trivial/tree_diagram.css";
import "../Style/trivial/tooltip.css";

import ErrorBoundary from "./ErrorHandler/ErrorBoundary";
import ErrorUI from "./ErrorHandler/ErrorUI";
import { ErrorProvider } from "./ErrorHandler/ErrorContext";
import ErrorUIBoundary from "./ErrorHandler/ErrorUIBoundary";
import NotFoundPage from "../Pages/dashboard/NotFoundPage";

import maplibregl from "maplibre-gl";
maplibregl.setWorkerUrl(`${process.env.PUBLIC_URL}/maplibre-gl-csp-worker.js`);

/* CONST & SAFARI FIXES */
let token_mapid = null;
let mapid_user = null;

// SAFARI FIX 1: Safely access localStorage to prevent strict-mode crashes
try {
  token_mapid = localStorage.getItem("token_mapid");
  mapid_user = localStorage.getItem("mapid_user");
} catch (error) {
  console.warn("Local storage is disabled or unavailable.");
}

if (token_mapid && token_mapid !== "undefined" && token_mapid !== "null") {
  try {
    if (mapid_user) {
      store.dispatch(setCurrentUser(JSON.parse(mapid_user)));
    }
  } catch (parseError) {
    console.error("Failed to parse user data from storage");
  }

  store.dispatch(getUserFromToken(token_mapid));
  store.dispatch(getUserPaymentList());
  store.dispatch(get_quota_access());
  store.dispatch(get_quota_access_sini_ai());
  store.dispatch(get_quota_ai_chat());

  // SAFARI FIX 2: Remove top-level await and wrap in an IIFE
  (async () => {
    try {
      await store.dispatch(optimized_get_user_license());
    } catch (err) {
      console.error("Failed to fetch user license", err);
    }
  })();
} else {
  store.dispatch(logoutUser());
}

class App extends Component {
  componentDidMount() {
    // Safely check language in local storage
    let language = "ina";
    try {
      language = localStorage.getItem("language") || "ina";
    } catch (e) {
      // Keep default "ina" if storage is blocked
    }
    store.dispatch(setLanguage(language));

    let prevPath = history.location.pathname;
    this.unlisten = history.listen((location, action) => {
      store.dispatch(setPrevPathname(prevPath));
      store.dispatch(setPathname(location.pathname));
      prevPath = location.pathname;
    });

    window.addEventListener("wheel", this.handleWheel, { passive: false });
  }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleWheel);
    if (this.unlisten) {
      this.unlisten();
    }
  }

  handleWheel = (e) => {
    const active = document.activeElement;
    if (
      active &&
      active.type === "number" &&
      active === document.activeElement
    ) {
      e.preventDefault(); // cegah scroll ubah angka
    }
  };

  render() {
    return (
      <Provider store={store}>
        <ErrorProvider>
          <ThemeProvider theme={muiTheme}>
            <Router history={history}>
              <ErrorBoundary fallback={<ErrorUIBoundary />}>
                <div>
                  <Switch>
                    <Route exact path="/" component={DashboardPublic} />
                    <Route exact path="/login" component={LandingLogin} />
                    <Route exact path="/login_qa" component={LandingLogin} />
                    <Route exact path="/register" component={LandingRegister} />
                    <Route
                      exact
                      path="/forget-password"
                      component={LandingForgetPassword}
                    />

                    <Route exact path="/blog_read/:link" component={BlogRead} />
                    <Route
                      exact
                      path="/public/:mode"
                      component={DashboardPublic}
                    />
                    <PrivateRoute exact path="/dashboard" component={PROJECT} />
                    <PrivateRoute
                      exact
                      path="/editor/:geo_project_link/:geo_layer_link?/:mode?"
                      component={PARENT_MAP_EDITOR}
                    />
                    <Route
                      exact
                      path="/view/:geo_project_link"
                      component={PARENT_MAP_VIEWER}
                    />
                    <PrivateRoute exact path="/bi/:link" component={BI_PAGE} />
                    <PrivateRoute
                      exact
                      path="/user_profile"
                      component={UserDashboard}
                    />
                    <PrivateRoute
                      exact
                      path="/editprofile"
                      component={EditProfile}
                    />
                    <PrivateRoute
                      exact
                      path="/routing_access"
                      component={RoutingAccess}
                    />
                    <PrivateRoute
                      exact
                      path="/form_editor/:geo_layer_link"
                      component={CreateForm}
                    />
                    <PrivateRoute
                      exact
                      path="/delete_account"
                      component={DeleteAccount}
                    />
                    <PrivateRoute
                      exact
                      path="/flood_analysis_system"
                      component={FloodSystemAnalysis}
                    />
                    <PrivateRoute
                      exact
                      path="/user_group/group"
                      component={() => (
                        <GROUP_LIST_DASHBOARD>
                          <GROUP_MENU />
                        </GROUP_LIST_DASHBOARD>
                      )}
                    />
                    <PrivateRoute
                      exact
                      path="/user_group/collaborator"
                      component={() => (
                        <GROUP_LIST_DASHBOARD>
                          <CollaboratorsMenu />
                        </GROUP_LIST_DASHBOARD>
                      )}
                    />
                    <PrivateRoute
                      exact
                      path="/group/:id"
                      component={GROUP_DETAIL}
                    />
                    <PrivateRoute
                      exact
                      path="/payment/:payment_id"
                      component={PaymentInstruction}
                    />
                    <PrivateRoute exact path="/recovery" component={Recovery} />
                    <Route path="*" component={NotFoundPage} />
                  </Switch>
                  <Navigation />
                  <MODAL_SHARE_LINK />
                  <style>{`
                    #startingLoader { 
                      display: none;
                    }
                    /* Ensure smooth transition */
                    body {
                      transition: opacity 0.3s ease-in-out;
                    }
                  `}</style>
                </div>
                <SNACKBAR_PARENT />
                <ErrorUI />
              </ErrorBoundary>
            </Router>
          </ThemeProvider>
        </ErrorProvider>
      </Provider>
    );
  }
}

export default App;
